import { useAuth } from "@workos-inc/authkit-react";

import type { FeatureFlagSlug } from "@/shared/config/featureFlags";

export function useFeatureFlags(): readonly string[] {
	const { featureFlags } = useAuth();
	return featureFlags;
}

export function useFeatureFlag(flagSlug: FeatureFlagSlug): boolean {
	const featureFlags = useFeatureFlags();
	return featureFlags.includes(flagSlug);
}
